<template>
  <ul :class="`list-group ${flush ? 'list-group-flush' : 'mx-3 mb-3'}`">
    <li
      v-for="item in items"
      :key="item.id"
      :ref="`item_${item.id}`"
      :class="`py-3 list-group-item list-group-item-action ${item.selected || selectedItemId === item.id ? 'bg-primary-fade bg-opacity-25' : ''} ${$ui.highlightedFromMap === item.id ? 'highlighted' : ''}`"
      @click="$emit('select', item.selected ? null : item.id)"
      @mouseenter="$ui.setHighlighted(item.id, 'list')"
      @mouseleave="$ui.clearHighlighted('list')"
    >
      <slot name="item" :item="item"/>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    items: Array,
    selectedItemId: String,
    flush: {
      type: Boolean,
      default: () => true
    }
  },
  emits: ['select'],
  watch: {
    selectedItemId() {
      this.scrollToSelected();
    }
  },
  mounted() {
    this.scrollToSelected();
  },
  beforeUnmount() {
    this.$ui.clearHighlighted('list');
  },
  methods: {
    scrollToSelected() {
      if (this.selectedItemId) {
        const ref = this.$refs[`item_${this.selectedItemId}`];
        if (ref && ref.length) {
          window.lastSelected = ref[0];
          ref[0].scrollIntoViewIfNeeded();
        }
      }
    }
  }
}
</script>

<style scoped>
.list-group-item:hover,
.list-group-item.highlighted {
  --bs-list-group-action-hover-bg: #eeeeee;
  background-color: #eeeeee;
}
</style>
